import { inject, Service } from '@angular/core';
import { ClientHttpService } from '@data-services/http/client-http.service';
import { HardwareMountingMinute } from './hardware-mounting-minute.model';
import { SaveHardwareMountingMinuteRequest } from './save-hardware-mounting-minute-request.model';

@Service()
export class HardwareMountingMinuteDataService {
  private readonly http = inject(ClientHttpService);

  async getHardwareMountingMinutesAsync(projectId: string, companyId: string): Promise<HardwareMountingMinute[]> {
    return await this.http.getObjectAsync<HardwareMountingMinute[]>(`projects/${projectId}/company/${companyId}/hardwaremm/all`);
  }

  async saveHardwareMountingMinutesAsync(projectId: string, companyId: string, minutes: SaveHardwareMountingMinuteRequest[]): Promise<void> {
    const saved = await this.http.postObjectAsync<SaveHardwareMountingMinuteRequest[], boolean>(
      `projects/${projectId}/company/${companyId}/hardwaremm`, minutes);
    if (!saved) {
      throw new Error('Saving hardware mounting minutes failed');
    }
  }
}
